import gql from "graphql-tag";

export const GetProfile = gql`
  {
    accounts {
      id
      username
      email
      name
      picture
      bio
      supportEmail
      website
      politicalDisclaimer
      statementDescriptor
      domainUrl
      brandDomainUrl
      isNmiAccount
      policies {
        privacyPolicyUrl
        termsOfServiceUrl
        refundPolicyUrl
      }
    }
  }
`;

export const GetBankAccount = gql`
  query GetBankAccount {
    accounts {
      id
      bank {
        digits
        name
      }
    }
  }
`;

export const GetAccountPreference = gql`
  query GetAccountPreference {
    accounts {
      username
      preference {
        id
        headingColor
        textColor
        backgroundColor
        backgroundImage
        brandLogo
        programFeatures
        programHighlight
      }
    }
  }
`;
